import './style.scss';

import { Filters, GridItem, Loader } from 'components';
import content from 'content.json';
import { useWithDispatch } from 'hooks';
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Col, Container, Image, Row } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory } from 'react-router-dom';
import { useProfileStore } from 'store/profile/reducer';
import { toggleModal } from 'store/ui/actions';
import { useUserStore } from 'store/user/reducer';
import {
    ClosetItem,
    ClosetQueryParameters,
    FilterOptionsParameters,
    FilterParams,
    FilterStruct
} from 'types/styling';
import { CustomError } from 'types/utils';

import Empty from './Empty';

const { profile: texts } = content;
interface ICloset {
    loading: boolean;
    loadingFilters: boolean;
    closet: ClosetItem[];
    filters: FilterStruct[];
    totalItems: string;
    selectedFilters: Record<string, FilterOptionsParameters[]>;
    error: CustomError;
    loadCloset: (input: ClosetQueryParameters) => void;
    loadClosetFilters: (fields: Record<string, string>) => void;
    updateFilters: (filter: FilterParams, isSelected: boolean, callback: () => void) => void;
}
const Closet: React.FC<ICloset> = ({
    loading,
    loadingFilters,
    closet,
    filters,
    totalItems,
    selectedFilters,
    error,
    loadCloset,
    loadClosetFilters,
    updateFilters
}) => {
    const history = useHistory();
    const resultsRef = useRef<HTMLDivElement>();
    const [gridItems, setGridItems] = useState<ClosetItem[]>([]);
    const user = useUserStore((store) => store.user);
    const gridSize = useProfileStore((store) => store.gridSize);
    const toggleModalAction = useWithDispatch(toggleModal);

    useEffect(() => {
        if (user) {
            loadClosetFilters({
                fields: 'categories,colors,retailers,prices,brands,sizes'
            });
            fetchData({});
        }
    }, [user]);

    useEffect(() => {
        if (!loading && closet) setGridItems(closet);
    }, [closet]);

    useEffect(() => {
        if (error && error.profile)
            toggleModalAction({ type: 'Error', data: { error: texts.errors.closet } });
    }, [error]);

    const fetchData = (filter?: Record<string, FilterOptionsParameters[]>) => {
        const activeFilters = filter ? filter : selectedFilters;
        const params = Object.keys(activeFilters).reduce(
            (ac, a) =>
                activeFilters[a].length
                    ? {
                          ...ac,
                          [a]: activeFilters[a].map((selection) => selection.key).join(',')
                      }
                    : ac,
            {}
        );
        loadCloset({ ...params, from: !filter && closet ? closet.length : 0 });
    };

    const onFilterChange = (filter: FilterParams) => {
        const isSelected =
            selectedFilters[filter.key] &&
            selectedFilters[filter.key].findIndex((item: FilterParams | FilterOptionsParameters) =>
                !Array.isArray(filter.value) ? item.key === filter.value.key : false
            ) > -1;
        updateFilters(filter, isSelected, fetchData);
    };
    const onItemRemove = (item: any) => toggleModalAction({ type: 'RemoveItem', data: item });

    const addItem = () => toggleModalAction({ type: 'AddClosetItem' });

    return (
        <Container className="profile-closet" fluid>
            <Row>
                <Col className="filters-column d-none d-md-block">
                    {loadingFilters && <Loader />}
                    <p className="total">{texts.items.replace('%count%', totalItems)}</p>
                    <Filters
                        className={
                            selectedFilters.category_uuid && !selectedFilters.category_uuid.length
                                ? 'categories-all'
                                : ''
                        }
                        filters={filters}
                        selected={selectedFilters}
                        setFilter={onFilterChange}
                        showSelection={true}
                    />
                </Col>
                <Col id="results" className="results" ref={resultsRef as any}>
                    {loading && <Loader />}

                    {gridItems.length ? (
                        <span>
                            <div className="results-bar">
                                <div className="filter-badges">
                                    {Object.keys(selectedFilters).map((key) =>
                                        selectedFilters[key]?.map((filter) => (
                                            <Badge variant="light" key={filter.key}>
                                                <div
                                                    className="close"
                                                    onClick={() =>
                                                        onFilterChange({ key, value: filter })
                                                    }
                                                />
                                                {filter.text}
                                            </Badge>
                                        ))
                                    )}
                                </div>
                            </div>
                            <InfiniteScroll
                                dataLength={gridItems ? gridItems.length : 0}
                                next={fetchData}
                                hasMore={true}
                                scrollableTarget="results"
                                loader={null}
                            >
                                {gridItems.map((item) => (
                                    <GridItem
                                        key={item.item_uuid}
                                        type="profile"
                                        size={gridSize}
                                        item={item}
                                        onDetailsClick={() => history.push(`/item/${item.uuid}`)}
                                        onImageClick={() =>
                                            toggleModalAction({
                                                type: 'Photo',
                                                data: item.picture_large
                                            })
                                        }
                                        onRemove={() => onItemRemove(item)}
                                    >
                                        {}
                                    </GridItem>
                                ))}
                            </InfiniteScroll>
                        </span>
                    ) : (
                        <Empty section="closet" />
                    )}
                    <div className="add-btn" onClick={addItem}>
                        {!gridItems.length && (
                            <div className="empty-add-text">
                                <p>{texts.add}</p>
                                <Image src={texts.addArrow} />
                            </div>
                        )}
                        <label>+</label>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
export default Closet;
